import { ApiObterCargos } from '@/api/cargos'
import { defineStore } from 'pinia'

export const Cargos = defineStore('Cargos', {
   state: () => ({
      cargos: null
   }),
   actions: {
      async ActionObterCargos() {
         await ApiObterCargos().then((resposta) => (this.cargos = resposta))
      }
   }
})
